export default __webpack_public_path__ + "static/media/Hot.0dc388a2.png";